import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const productAddToCardWrapper = css`
  display: flex;
  justify-content: flex-start;
`;

export const skeletonImage = css`
  &&& {
    width: 8.125rem;
    height: 8.125rem;
  }
  margin: auto;
  margin-bottom: 1rem;
`;

export const skeletonImageWide = css`
  &&& {
    width: 10rem;
    height: 10rem;
  }
`;

export const wrapperWide = css`
  padding: 0;
`;

export const wideCardImageColumn = css`
  border-radius: ${dimensions.borderRadius} 0 0 ${dimensions.borderRadius};
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;

  @media only screen and (max-width: ${dimensions.phoneLargeMax}) {
    border-radius: ${dimensions.borderRadius} ${dimensions.borderRadius} 0 0;
    padding-top: 1rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
`;

export const productInformationColumn = css`
  padding: 1.5rem;

  @media only screen and (min-width: ${dimensions.tablet}) {
    padding: 2rem 2rem 2rem 4rem;
  }
  @media only screen and (min-width: ${dimensions.desktop}) {
    padding: 3rem 2rem 3rem 5rem;
  }
`;
